var $35e811a055cd3a1f$exports = {};
$35e811a055cd3a1f$exports = {
    "loading": `U\u{10D}itavam...`,
    "placeholder": `Izaberite...`
};


export {$35e811a055cd3a1f$exports as default};
//# sourceMappingURL=sr-SP.mjs.map
